import { render, staticRenderFns } from "./Vendortype.vue?vue&type=template&id=6a9d81f7&"
import script from "./Vendortype.vue?vue&type=script&lang=js&"
export * from "./Vendortype.vue?vue&type=script&lang=js&"
import style0 from "./Vendortype.vue?vue&type=style&index=0&id=6a9d81f7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports